import { useEffect, useState } from "react";
import { fetchPrivateFile } from "@/lib/api";

export const usePrivateImage = (path, enabled = true) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!path || !enabled) { setSrc(null); return undefined; }
    let url;
    let cancelled = false;
    fetchPrivateFile(path)
      .then((u) => { if (cancelled) { URL.revokeObjectURL(u); return; } url = u; setSrc(u); })
      .catch(() => setSrc(null));
    return () => { cancelled = true; if (url) URL.revokeObjectURL(url); };
  }, [path, enabled]);
  return src;
};

export const PrivateImage = ({ path, alt, className, testid }) => {
  const src = usePrivateImage(path);
  if (!src) return <div className={`bg-slate-100 animate-pulse ${className}`} />;
  return <img src={src} alt={alt} className={className} data-testid={testid} />;
};
